import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70f59de8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-shrink-0 d-flex align-items-center justify-content-between header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "ml-4 my-0",
  href: "#",
  style: {"color":"#8a2a2a","font-family":"Urbanist,sans-serif","font-weight":"800"}
}, "antara", -1))
const _hoisted_3 = {
  id: "sidebar",
  class: "flex-shrink-1 flex-grow-1 pb-3 pt-3 pt-lg-0",
  style: {"overflow":"auto","min-height":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar flex-shrink-0 mr-lg-4", { 'sidebar-hidden': !_ctx.globalState.sidebarVisible, 'mobile-sidebar': _ctx.breakpointUtil.isOnMobile }]),
    style: {"min-width":"0"}
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["card bg-white h-100 w-100", _ctx.classes])
    }, [
      (_ctx.breakpointUtil.isOnMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_Button, {
              class: "p-button-text flat mr-2",
              icon: "pi pi-times",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.globalState.sidebarVisible = !_ctx.globalState.sidebarVisible), ["stop","prevent"]))
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ], 2)
  ], 2))
}